import { getWandaServiceArea } from "../services";
import { notification } from "antd";
import {
  defaultPastDateRange,
  defaultUpcomingDateRange,
  ITripDateRange,
  IWandaServiceArea,
} from "../types/TripTypes";
import moment from "moment";
import { ITripDetails } from "../components/ServiceUsers/Interfaces/ITripDetails";

const getWandaServiceAreaHelper = async (
  zip: string,
  recaptchaToken?: string
): Promise<IWandaServiceArea[]> => {
  try {
    let serviceArea: IWandaServiceArea[] = await getWandaServiceArea(
      zip,
      recaptchaToken
    );
    return serviceArea;
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to get wanda service area.",
    });
    throw error;
  }
};

export default getWandaServiceAreaHelper;

export function isValidDateString(dateStr: string): boolean {
  return !!(
    dateStr &&
    !(dateStr === "0001-01-01T00:00:00Z" || dateStr === "0001-01-01T00:00:00")
  );
}

export function formatDateUtc(dateStr: string | null): string {
  return dateStr && isValidDateString(dateStr)
    ? moment.utc(dateStr).format("MM/DD/YYYY")
    : "";
}

export function isPastDateRangeChanged(pastDateRange: ITripDateRange) {
  if (
    pastDateRange.startDate !== defaultPastDateRange().startDate ||
    pastDateRange.endDate !== defaultPastDateRange().endDate
  ) {
    return true;
  } else {
    return false;
  }
}

export function isUpcomingDateRangeChanged(upcomingDateRange: ITripDateRange) {
  if (
    upcomingDateRange.startDate !== defaultUpcomingDateRange().startDate ||
    upcomingDateRange.endDate !== defaultUpcomingDateRange().endDate
  ) {
    return true;
  } else {
    return false;
  }
}

export function getGrandTotalCost(trip: ITripDetails[]) {
  return {
    tripCostWithDiscount: trip
      .reduce((acc: number, leg: ITripDetails) => leg.tripCost + acc, 0)
      .toFixed(2),
    tripCostWithoutDiscount: trip
      .reduce(
        (acc: number, leg: ITripDetails) =>
          leg.transportationCost +
          leg.levelOfServiceCost +
          leg.vehicleTypeCost +
          acc,
        0
      )
      .toFixed(2),
  };
}
